import React from 'react';
import { Segment, Grid, Divider, Button, Table, Icon, Label, Message, Confirm } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import SegmentationCharts from '../common/SegmentationCharts'

/**
 * Changes component
 */
export default class ShowChanges extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
			openRemovePanelChangeDialog: false,
			openRemoveRequestDialog: false
        }
	}	

	handleShowConfirmRemovePanelChange = (id) => this.setState({ openRemovePanelChangeDialog: true, removePanelChangeId: id })
	handleCloseConfirmRemovePanelChange = () => this.setState({ openRemovePanelChangeDialog: false, removePanelChangeId: undefined })
	handleConfirmedRemovePanelChange = () => { this.handleRemovePanelChange(this.state.removePanelChangeId); this.setState({ openRemovePanelChangeDialog: false }); }
  
	/**
	 * Remove a panel change
	 */
	handleRemovePanelChange(panelChangeId) {
		this.props.removePanelChange(panelChangeId)
	}	

	handleShowConfirmRemoveRequest = (id) => this.setState({ openRemoveRequestDialog: true, removeRequestId: id })
	handleCloseConfirmRemoveRequest = () => this.setState({ openRemoveRequestDialog: false, removeRequestId: undefined })
	handleConfirmedRemoveRequest = () => { this.handleRequestRemove(this.state.removeRequestId); this.setState({ openRemoveRequestDialog: false }); }
  
	/**
	 * Remove this request
	 * @param {*} requestId 
	 */
	handleRequestRemove(requestId) {
		this.props.removeRequest(requestId);
	}

	/**
	 * Calculate panel state AFTER all pending changes are applied
	 * This shows the visitor what their panel will look like after approval
	 */
	calculatePanelAfterChanges = () => {
		// Start with current panel
		let futurePanel = [...this.props.actualPanel];

		// Apply all panel changes
		this.props.panelChanges.forEach(pc => {
			switch (pc.requestType) {
				case 'add':
					// Add new target
					futurePanel.push({
						name: pc.name,
						license: pc.license,
						segmentation: pc.newSegmentation,
						myPreferredSpecialtyHu: pc.newMyPreferredSpecialtyHu,
						postalCode: pc.newPostalCode,
						city: pc.newCity,
						address: pc.newAddress
					});
					break;
				case 'remove':
					// Remove target
					futurePanel = futurePanel.filter(t => t.license !== pc.license);
					break;
				case 'modify':
					// Modify target
					const targetIndex = futurePanel.findIndex(t => t.license === pc.license);
					if (targetIndex !== -1) {
						futurePanel[targetIndex] = {
							...futurePanel[targetIndex],
							segmentation: pc.newSegmentation || futurePanel[targetIndex].segmentation,
							myPreferredSpecialtyHu: pc.newMyPreferredSpecialtyHu || futurePanel[targetIndex].myPreferredSpecialtyHu
						};
					}
					break;
				default:
					break;
			}
		});

		// Apply new target requests
		this.props.requests.forEach(req => {
			if (req.requestType === 'target') {
				futurePanel.push({
					name: req.name,
					license: req.stamp,
					segmentation: req.segmentation,
					myPreferredSpecialtyHu: req.myPreferredSpecialtyHu,
					postalCode: req.postalCode,
					city: req.city,
					address: req.address
				});
			}
		});

		return futurePanel;
	}

	/**
	 * Init
	 */
	componentDidMount() {
		this.props.fetchRequests(this.props.visitorTerritory);
		this.props.fetchPanelChanges(this.props.visitorTerritory);
		if (this.props.actualPanel.length === 0)
		{
			this.props.fetchPanel(this.props.visitorTerritory);
		}		
	}

	/**
	 * Generate panel change based table row
	 * @param {*} panelChange 
	 */	
	generateRowFromPanelChange(panelChange, index, that, accepted = false) {
		switch (panelChange.requestType)
		{
			case 'add':
				return <Table.Row key={ index }>
							<Table.Cell positive={accepted}>&nbsp; <Icon title='Panelbe felvesz' color='green' name='arrow right' /><br/><br/></Table.Cell>
							<Table.Cell positive={accepted}><b>{ panelChange.name }</b><br/>{ panelChange.license }<br/><Label basic color='green'>{ panelChange.newSegmentation }</Label><Label basic color='green'>{ panelChange.newMyPreferredSpecialtyHu === undefined || panelChange.newMyPreferredSpecialtyHu.length > 50 ? 'HIBÁS SZAKTERÜLET' : panelChange.newMyPreferredSpecialtyHu }</Label></Table.Cell>
							<Table.Cell positive={accepted} textAlign='right' width={5}>
								{
									accepted ? ''
									:								
									<Button color='red' onClick={ () => that.handleShowConfirmRemovePanelChange(panelChange.id) } icon><Icon name='trash'/></Button>
								}			
							</Table.Cell>
							{
								accepted ?
								<Table.Cell positive={accepted}><Icon name='check' color='green'/> { panelChange.createdAt.substring(0,10) } &nbsp; </Table.Cell>
								:
								''			
							}							
						</Table.Row>				
			case 'remove':
				return <Table.Row key={ index }>						
							<Table.Cell positive={accepted}>&nbsp; <Icon title='Panelből kitesz' color='red' name='arrow left' /></Table.Cell>
							<Table.Cell positive={accepted}><b>{ panelChange.name }</b><br/>{ panelChange.license }</Table.Cell>
							<Table.Cell positive={accepted} textAlign='right' width={5}>
								{
									accepted ? ''
									:								
									<Button color='red' onClick={ () => that.handleShowConfirmRemovePanelChange(panelChange.id) } icon><Icon name='trash'/></Button>
								}
							</Table.Cell>
							{
								accepted ?
								<Table.Cell positive={accepted}><Icon name='check' color='green'/> { panelChange.createdAt.substring(0,10) } &nbsp; </Table.Cell>
								:
								''			
							}								
						</Table.Row>						
			case 'modify':
				return <Table.Row key={ index }>
							<Table.Cell positive={accepted}>&nbsp; <Icon title='Panelban módosít' color='blue' name='edit' /></Table.Cell>
							{
								panelChange.frequencyRequest === null
								?
								<Table.Cell positive={accepted}><b>{ panelChange.name }</b><br/>{ panelChange.license }<br/><Label basic color='blue'>{ panelChange.newSegmentation }</Label> <Label basic color='blue'>{ panelChange.newMyPreferredSpecialtyHu === undefined || panelChange.newMyPreferredSpecialtyHu.length > 50 ? 'HIBÁS SZAKTERÜLET' : panelChange.newMyPreferredSpecialtyHu }</Label></Table.Cell>
								:
								<Table.Cell positive={accepted}><b>{ panelChange.name }</b> <Label basic>FREK. <Icon name='arrow down'/></Label><br/>{ panelChange.license }<br/>Indoklás: <i>{ panelChange.frequencyRequest }</i></Table.Cell>
							}
							<Table.Cell positive={accepted} textAlign='right' width={5}>
								{
									accepted ? ''
									:
									<Button color='red' onClick={ () => that.handleShowConfirmRemovePanelChange(panelChange.id) } icon><Icon name='trash'/></Button>
								}
							</Table.Cell>
							{
								accepted ?
								<Table.Cell positive={accepted}><Icon name='check' color='green'/> { panelChange.createdAt.substring(0,10) } &nbsp; </Table.Cell>
								:
								''			
							}
						</Table.Row>						
			default: return '';
		}
	}

	/**
	 * Generate request based table row
	 * @param {*} request 
	 */
	generateRowFromRequest(request, index, that, accepted = false) {
		switch (request.requestType)
		{
			case 'address':
				return <Table.Row key={ index }>
							<Table.Cell positive={accepted}>&nbsp;<Icon color='blue' name='home' /><br/><br/></Table.Cell>
							<Table.Cell positive={accepted}><span style={{ 'color': '#aaa' }}>{ request.name }</span>&nbsp;<Label basic>ÚJ CÍM</Label><br/>{ request.city + ', ' + request.postalCode + ', ' + request.address }</Table.Cell>
							<Table.Cell positive={accepted} textAlign='right' width={5}>
								{
									accepted ? ''
									:								
									<Button color='red' onClick={ () => that.handleShowConfirmRemoveRequest(request.id) } icon><Icon name='trash'/></Button>
								}
							</Table.Cell>
							{
								accepted ?
								<Table.Cell positive={accepted}><Icon name='check' color='green'/> { request.createdAt.substring(0,10) } &nbsp; </Table.Cell>
								:
								''			
							}							
						</Table.Row>				
			case 'target':
				return <Table.Row key={ index }>
							<Table.Cell positive={accepted}>&nbsp;<Icon color='blue' name='user' /></Table.Cell>
							<Table.Cell positive={accepted}><b>{ request.name }</b>&nbsp;<Label basic>ÚJ CÉLPONT</Label><br/>Pecsétszám: { request.stamp }<br/><Label basic>{ request.segmentation }</Label> <Label basic>{ request.myPreferredSpecialtyHu }</Label><br/>{ request.city + ', ' + request.postalCode + ', ' + request.address }</Table.Cell>
							<Table.Cell positive={accepted} textAlign='right' width={5}>
								{
									accepted ? ''
									:								
									<Button color='red' onClick={ () => that.handleShowConfirmRemoveRequest(request.id) } icon><Icon name='trash'/></Button>
								}
							</Table.Cell>
							{
								accepted ?
								<Table.Cell positive={accepted}><Icon name='check' color='green'/> { request.createdAt.substring(0,10) } &nbsp; </Table.Cell>
								:
								''			
							}							
						</Table.Row>						
			default: return '';
		}
	} 

	render() {

		// Calculate future panel state
		const futurePanel = this.calculatePanelAfterChanges();

		return  <Segment basic loading={ this.props.isLoading || this.props.isRemovingRequest || this.props.isRemovingPanelChange }>
                    { this.props.error === undefined ? '' : <Message error>Hiba történt. { this.props.error }</Message> }								
					<h3><Icon name='exchange'/> Igények</h3>
					Hatályos változtatási kéréseidet látod illetve vonhatod vissza itt. A központ a <b>panelváltoztatási időszak végén lezárja</b> a kéréseket és átvezeti a paneleden.
					<Divider/>
					<Grid stackable>
						<Grid.Row>
							<Grid.Column width={12}>
								<div>
									<h3><Icon name='exchange'/> Jelenlegi igények</h3>
									{
										this.props.panelChanges.length + this.props.requests.length === 0
										?
										<center style={{ color: '#aaa' }}>Nem található elbírálatlan kérés.</center>
										:
										<Table unstackable basic='very' selectable>
											<Table.Body>
											{
												this.props.panelChanges.map( (pc, index) => {
													return this.generateRowFromPanelChange(pc, index, this);
												}, this)
											}
											{
												this.props.requests.map( (request, index) => {
													return this.generateRowFromRequest(request, index, this);
												}, this)
											}
											</Table.Body>
										</Table>
									}
									<Divider/>
									<h3><Icon name='history'/> Korábbi igények</h3>
									<Table unstackable basic='very'>
										<Table.Body>
										{
											this.props.oldPanelChanges.map( (pc, index) => {
												return this.generateRowFromPanelChange(pc, index, this, true);
											}, this)
										}
										{
											this.props.oldRequests.map( (request, index) => {
												return this.generateRowFromRequest(request, index, this, true);
											}, this)
										}										
										</Table.Body>
									</Table>									
								</div>
							</Grid.Column>
							<Grid.Column width={4}>
								<SegmentationCharts 
									panelData={futurePanel} 
									title="Várható panel jóváhagyás után"
								/>
							</Grid.Column>
						</Grid.Row>
					</Grid>
					<Divider/>
					<Link to='/panelChanges'><Button basic primary>Vissza</Button></Link>
					<Confirm
						open={ this.state.openRemovePanelChangeDialog }
						onCancel={ this.handleCloseConfirmRemovePanelChange }
						cancelButton='Mégsem'
						content='Biztosan törlöd ezt a panelváltoztatást?'
						confirmButton='Igen'
						onConfirm={ this.handleConfirmedRemovePanelChange }
					></Confirm>					
					<Confirm
						open={ this.state.openRemoveRequestDialog }
						onCancel={ this.handleCloseConfirmRemoveRequest }
						cancelButton='Mégsem'
						content='Biztosan törlöd ezt a paneváltoztatást?'
						confirmButton='Igen'
						onConfirm={ this.handleConfirmedRemoveRequest }
					></Confirm>						
				</Segment>
	}
}
